import Badge from '@cloudscape-design/components/badge'

interface AccountPlatform {
  platform: string
  connected: boolean
  email?: string | null
}

interface SenderEmailBadgeProps {
  platforms: AccountPlatform[]
  defaultEmailProvider: string | null | undefined
}

export default function SenderEmailBadge({ platforms, defaultEmailProvider }: SenderEmailBadgeProps) {
  if (!defaultEmailProvider) return null

  const match = platforms.find(
    (p) => p.platform === defaultEmailProvider && p.connected && p.email,
  )

  if (!match?.email) return null

  return <Badge color="blue">{match.email}</Badge>
}
